Historical weightings from the stocks level are aggregated to form the historical
category weights.
